import { combineReducers } from 'redux'

import theme from './reducers/themeReducer'
import user from './reducers/userReducer'
import roster from './reducers/rosterReducer'
import auction from './reducers/auctionReducer'
import interfaceModal from './reducers/playerInterfaceModalReducer'
import league from './reducers/leagueReducer'
import transaction from './reducers/transactionReducer'
import draft from './reducers/draftReducer'
import socket from './reducers/socketReducer'

const rootReducer = combineReducers({
  theme,
  user,
  roster,
  auction,
  interfaceModal,
  league,
  transaction,
  draft,
  socket,
})

export default rootReducer
